<template>
  <div>
    <b-input-group class="mb-3">
      <b-form-input
        style="width:130px"
        v-model="input_date"
        type="text"
        :placeholder="placeholder"
        autocomplete="off"
        :required="required"
        :disabled="disabled"
      >
      </b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="pick_date"
          button-only
          right
          locale="en-US"
          start-weekday="1"
          aria-controls="ngaysinh-input"
          :disabled="disabled"
        >
        </b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "MyDatePicker",
  props: ["value", "required", "disabled", "placeholder"],
  data() {
    return {
      pick_date: null,
    };
  },
  watch: {
    pick_date: function(newValue, oldValue) {
      if (newValue != null) {
        var date_split = newValue.split("-");
        this.input_date =
          date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
    },
  },
  computed: {
    input_date: {
      get: function() {
        if (this.value == null || this.value == "Invalid Date") return "";
        if (!this.value.includes("/") && this.value.length > 10) {
          return this.$convert_date_string(this.value);
        }
        return this.value;
      },
      set: function(modifiedValue) {
        this.$emit("input", modifiedValue);
      },
    },
  },
};
</script>
